module.exports = ".snack-bar {\n  color: lightblue; }\n"